require( './bootstrap' );
// add lazy-load supported
import LazyLoad from "vanilla-lazyload";

document.addEventListener(
    'DOMContentLoaded',
    function () {
      let myLazyLoad = new LazyLoad( {
        elements_selector: ".lazy-load"
      } );
    }
);

window.onscroll = function () {fixedIsActive()};
let container = document.getElementById("top");
function fixedIsActive() {
  if(window.pageYOffset > container.offsetTop){

    container.classList.add("fixed");
  }else{
    container.classList.remove("fixed");
  }
}
